import { Module, Action, Mutation } from "vuex-module-decorators";
import { httpServer as http } from "@/http/tbrScanAxios";
import PaginationModule from "@/store/base-modules/PaginationModule";
import type { PaginationDataState } from "@/types";
import { RootState } from "@/store";

export interface WarrantyState extends PaginationDataState {
  recordType: string;
  searchCondition: any;
  statusTab: string;
}

const defaultSearchInstance = () => ({
  keyword: "",
  startTime: "",
  endTime: ""
});

@Module({ name: "WarrantyModule", namespaced: true })
export default class WarrantyModule
  extends PaginationModule<WarrantyState, RootState>
  implements WarrantyState {
  public listData: any[] = [];
  public recordType = "";
  public searchCondition: any = defaultSearchInstance();
  public statusTab = "";

  @Mutation
  setRecordTypeMutation(data: string) {
    this.recordType = data || "";
  }

  @Mutation
  saveListDataMutation(data: any[] = []) {
    this.listData = data || [];
  }

  @Mutation
  addListDataMutation(data: any[] = []) {
    this.listData.push(...(data || []));
  }

  @Mutation
  setSearchConditionMutation({ key = "", value = "" } = {}) {
    if (!key && !value) {
      this.searchCondition = defaultSearchInstance();
    } else {
      this.searchCondition[key] = value;
    }
  }

  @Mutation
  setStatusTabMutation(status = "") {
    this.statusTab = status || "";
  }

  @Action
  async queryListAction({ callback = data => data } = {}) {
    const {
      state: {
        paginationData,
        searchCondition,
        paginationData: { pageNum, pageSize }
      },
      commit
    } = this.context;

    const res = await http("/k2-scan/api/guarantee-card-record/queryPage", {
      pageNum,
      pageSize,
      attribute: searchCondition.keyword || "",
      boundStartTime: searchCondition.startTime || "",
      boundEndTime: searchCondition.endTime || "",
      guaranteeCardType: searchCondition.guaranteeCardType || "",
      guaranteeCardStatus: searchCondition.guaranteeCardStatus || "",
      is400Query: false
    });

    const totalCount = res?.data?.total || 0;
    let data = res?.data?.list || [];

    data = data.map(item => {
      const spe = [item.specifications, item.pattern, item.level]
        .filter(Boolean)
        .join(" ");

      return {
        ...item,
        createTime: item.cardGenerateTime || "",
        recordCode: item.guaranteeCardNo,
        batchCode: item.outboundBatchNo || "",
        status: item.guaranteeCardStatus,
        scanCount: 1,
        detailList: spe
          ? [
              {
                spe,
                quantity: 1,
                tireCode: item.tireCode
              }
            ]
          : []
      };
    });

    data = await callback(data);

    commit(
      pageNum === 1 ? "saveListDataMutation" : "addListDataMutation",
      data
    );
    commit("savePaginationData", { ...paginationData, totalCount });
  }

  @Action
  async queryGuaranteeCardRecordDetailsByCardNo(params: any = {}) {
    const res = await http(
      "/k2-scan/api/guarantee-card-record/queryGuaranteeCardRecordDetailsByCardNo",
      {
        guaranteeCardNo: params.guaranteeCardNo || "",
        is400Query: false
      }
    );
    return res;
  }
}
